export const posthogApiKey = process.env.POSTHOG_API_KEY;
export const posthogHostUrl =
  process.env.POSTHOG_API_HOST ?? "https://us.i.posthog.com";
export const clarityProjectId = process.env.CLARITY_PROJECT_ID ?? "";
export const analyticsEnabled = process.env.ANALYTICS_ENABLED === "true";
export const analyticsEnvironment =
  process.env.ANALYTICS_ENVIRONMENT ?? "staging";
